// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Compte_mail__a7zvN {\n  position: relative;\n}\n.Compte_titre__L5OAQ.Compte_warning__3rHi0 {\n  color: var(--color-red);\n}\n.Compte_mobile__2_Qmx {\n  margin-top: var(--root-mobile);\n}\n.Compte_desktop__1yG-b {\n  margin-top: var(--root-desktop);\n}\n", "",{"version":3,"sources":["webpack://src/Components/Compte/Compte.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC","sourcesContent":[".mail {\n  position: relative;\n}\n.titre.warning {\n  color: var(--color-red);\n}\n.mobile {\n  margin-top: var(--root-mobile);\n}\n.desktop {\n  margin-top: var(--root-desktop);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mail": "Compte_mail__a7zvN",
	"titre": "Compte_titre__L5OAQ",
	"warning": "Compte_warning__3rHi0",
	"mobile": "Compte_mobile__2_Qmx",
	"desktop": "Compte_desktop__1yG-b"
};
export default ___CSS_LOADER_EXPORT___;
